// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__Oao8e","bigColWidth":"Table_bigColWidth__1pIG1","biggerColWidth":"Table_biggerColWidth__L2Bwo","row":"Table_row__XKomM","col":"Table_col__RVKE1"};